import React from "react";
import styled, { css } from "styled-components";
import backIcon from "./icons/backIcon.svg";

export const cardStyle = css`
    border-radius: 6px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
`;

export const inputStyle = css`
    border-radius: 5px;
    border: 1px solid #f4f4f4;
    background: #fff;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
`;

export const menuStyle = css`
    background: #ffffff;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
`;

export const InvoicingContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 0px 120px;
    justify-content: space-between;
    gap: 20px;
    .card-form-view__content {
        width: calc(100% - 251px);
    }

    @media (max-width: 1115px) {
        padding: 0px 24px;
        .card-form-view__content {
            margin-left: 20px;
        }
    }

    @media (max-width: 767px) {
        padding: 0px;
        .card-form-view__content {
            width: 100%;
            justify-content: center;
            margin-left: 0px;
        }
    }
`;

export const InvoicingContent = styled.div`
    width: calc(100% - 251px);
    .kuda-inner--heading {
        margin-top: 30px;
        line-height: normal;
    }

    @media (max-width: 1115px) {
        margin-left: 20px;
    }

    @media (max-width: 767px) {
        width: 100%;
        justify-content: center;
        margin-left: 0px;
    }
`;

export const InvoicingForm = styled.div`
    ${cardStyle};
    width: 560px;
    max-width: 100%;
    margin-top: 48px;
    padding: 48px 70px 40px;

    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 992px) {
        width: 480px;
        padding: 48px 60px 40px;
    }

    @media screen and (max-width: 767px) {
        padding: 48px 40px 40px;
    }

    @media screen and (max-width: 480px) {
        padding: 48px 24px 40px;
    }
`;

const BackWrapper = styled.div`
    position: absolute;
    top: 27px;
    left: 25px;
    cursor: pointer;
    img {
        margin-right: 14.6px;
    }
`;

export const Heading = styled.div`
    position: relative;
    .invoicing__summary-cancelicon_small {
        position: absolute;
        right: 0px;
        top: 5px;
        width: 29px;
        height: 29px;
    }

    @media screen and (min-width: 768px) {
        .invoicing__summary-cancelicon_small {
            display: none;
        }
    }
`;

export const SummaryContainer = styled.div`
    min-height: 429px;
    padding: 17px 16px;
    width: 100%;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
    background: var(--whiteColor);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    position: relative;

    .invoicing__summary-cancelicon {
        position: absolute;
        right: 20px;
        top: 16px;
        width: 29px;
        height: 29px;
        display: none;
    }

    @media screen and (min-width: 768px) {
        width: auto;
        margin-left: -70px;
        margin-right: -70px;
        padding: 64px 43px 44px;

        .invoicing__summary-cancelicon {
            display: block;
        }
        .invoicing__summary-cancelicon_small {
            display: none;
        }
    }

    @media screen and (min-width: 992px) {
        margin-left: -100px;
        margin-right: -100px;
        padding: 63px 95px;
        width: auto;
    }
`;

export const emptyIllustration =
    '<svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31.5" cy="31.5" r="31.5" fill="#DBDCE0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M38.0797 35.5467H36.7409L36.2756 35.0847C37.9195 33.1677 38.9193 30.6824 38.9193 27.9594C38.9193 21.9065 34.0129 17 27.9599 17C21.9069 17 17.0005 21.9065 17.0005 27.9594C17.0005 34.0124 21.9069 38.9189 27.9599 38.9189C30.6829 38.9189 33.1665 37.9207 35.0835 36.2785L35.5489 36.7405V38.0758L43.9758 46.491L46.4897 43.977L38.0797 35.5467ZM27.9599 35.5467C23.7683 35.5467 20.3726 32.151 20.3726 27.9594C20.3726 23.7696 23.7683 20.3722 27.9599 20.3722C32.1498 20.3722 35.5472 23.7696 35.5472 27.9594C35.5472 32.151 32.1498 35.5467 27.9599 35.5467Z" fill="white"/></svg>';

export const prevIcon =
    '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.35809 0.284947L0.194768 6.52476C-0.0649227 6.78742 -0.0649227 7.21178 0.194768 7.47512L6.35809 13.7149C6.73298 14.0949 7.34292 14.0949 7.71847 13.7149C8.09336 13.3349 8.09336 12.7182 7.71847 12.3382L2.44609 6.9996L7.71847 1.6624C8.09336 1.28171 8.09336 0.664957 7.71847 0.284947C7.34292 -0.0950632 6.73298 -0.0950632 6.35809 0.284947Z" fill="#979797"/></svg>';
export const nextIcon =
    '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.64191 0.284947L7.80523 6.52476C8.06492 6.78742 8.06492 7.21178 7.80523 7.47512L1.64191 13.7149C1.26702 14.0949 0.657083 14.0949 0.281531 13.7149C-0.0933557 13.3349 -0.0933557 12.7182 0.281531 12.3382L5.55391 6.9996L0.281531 1.6624C-0.0933557 1.28171 -0.0933557 0.664958 0.281531 0.284947C0.657083 -0.0950629 1.26702 -0.0950629 1.64191 0.284947Z" fill="#979797"/></svg>';

export const BackButton = ({ handleBack }) => {
    return (
        <BackWrapper onClick={handleBack} className="flex align-center">
            <img src={backIcon} alt="" /> <p className="color-primary">Back</p>
        </BackWrapper>
    );
};
